import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { descobrirContrato } from '../actions/ContratoActions';
import { obterFormandosPeloContrato } from '../actions/FormandoActions';
import { obterArrobasPeloContrato } from '../actions/InstagramActions';
import { URL_DIAGRAMADOR_PERSONALIZACAO } from '../config/urls';

import $ from 'jquery';

class Menu extends React.Component {
  constructor(props) {
    super(props);
  }

  async componentWillMount() {
    await this.props
      .descobrirContrato(
        this.props.usuario.tipo,
        this.props.usuario.tipo === 'formando'
          ? this.props.numeroContrato
          : this.props.usuario.id
      )
      .then(async () => {
        await this.props.obterFormandosPeloContrato(this.props.contrato.id);
        await this.props.obterArrobasPeloContrato(this.props.contrato.id);
      });
  }

  fecharMenu() {
    $('#overlay-menuPrincipal').css('display', 'none');
    $('body').removeClass('sidebar-open');
  }

  _verificarConviteAprovado() {
    if (!this.props.contrato.publicacoes || this.props.contrato.publicacoes.length === 0) {
      return false;
    }

    const publicacoesConvite = this.props.contrato.publicacoes.filter(pub =>
      pub.visivel && (
        pub.tipo === 'Convite Simples' ||
        pub.tipo === 'Senha de Entrada' ||
        pub.tipo === 'Missal' ||
        pub.tipo === 'Outros Produtos' ||
        pub.tipo === 'Paginação' ||
        pub.tipo === 'Capa Dura' ||
        pub.tipo === 'Encarte' ||
        pub.tipo === 'Embalagens'
      )
    );

    if (publicacoesConvite.length === 0) {
      return false;
    }

    const todasAprovadas = publicacoesConvite.every(pub => pub.dataAprovacao !== null);
    return todasAprovadas;
  }

  _getCommonStyles() {
    return {
      menuItemStyle: {
        margin: '3px 8px',
        borderRadius: '6px',
        overflow: 'visible',
        transition: 'all 0.2s ease',
        background: 'transparent',
        border: '1px solid transparent',
        position: 'relative'
      },
      activeMenuItemStyle: {
        margin: '3px 8px',
        borderRadius: '6px',
        overflow: 'visible',
        transition: 'all 0.2s ease',
        background: '#dc2626',
        border: '1px solid #dc2626',
        position: 'relative'
      },
      linkStyle: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 10px',
        color: '#e5e5e5',
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        position: 'relative',
        gap: '10px'
      },
      activeLinkStyle: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 10px',
        color: '#ffffff',
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        position: 'relative',
        gap: '10px',
        fontWeight: '600'
      },
      iconContainerStyle: {
        width: '25px',
        height: '25px',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'transparent',
        transition: 'all 0.2s ease',
        flexShrink: 0
      },
      activeIconContainerStyle: {
        width: '30px',
        height: '30px',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(255, 255, 255, 0.4)',
        transition: 'all 0.2s ease',
        flexShrink: 0
      },
      iconStyle: {
        fontSize: '18px',
        color: 'inherit'
      },
      textContainerStyle: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minWidth: 0,
        gap: '8px',
        overflow: 'hidden'
      },
      labelTextStyle: {
        fontSize: '14px',
        letterSpacing: '0px',
        fontWeight: '500',
        flex: 1,
        minWidth: 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        transition: 'opacity 0.2s ease'
      },
      badgeStyle: {
        padding: '3px 6px',
        borderRadius: '4px',
        fontSize: '10px',
        fontWeight: '600',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '20px',
        height: '20px'
      },
      successBadgeStyle: {
        padding: '0',
        borderRadius: '50%',
        fontSize: '10px',
        fontWeight: '600',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '12px',
        height: '12px',
        background: '#10b981',
        color: '#fff'
      },
      dangerBadgeStyle: {
        padding: '0',
        borderRadius: '50%',
        fontSize: '10px',
        fontWeight: '600',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '12px',
        height: '12px',
        background: '#ef4444',
        color: '#fff'
      },
      infoBadgeStyle: {
        padding: '1.5px 3px',
        borderRadius: '4px',
        fontSize: '10px',
        fontWeight: '600',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '20px',
        height: '20px',
        background: '#737373',
        color: '#fff'
      },
      badgeIconStyle: {
        fontSize: '9px'
      }
    };
  }

  _renderMenuComissao() {
    const styles = this._getCommonStyles();

    return (
      <ul className='sidebar-menu' style={{ padding: '10px 0', listStyle: 'none', margin: 0 }}>
        {/* 1) Contrato */}
        <li
          onClick={this.fecharMenu.bind(this)}
          style={this.props.path === '/' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/' style={this.props.path === '/' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fas fa-file-alt' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Contrato</span>
              <small style={styles.infoBadgeStyle}>
                <i className='fa fa-info-circle' style={styles.badgeIconStyle} />
              </small>
            </div>
          </Link>
        </li>
        {/* 2) Formandos */}
        <li
          onClick={this.fecharMenu.bind(this)}
          style={this.props.path === '/formandos' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/formandos') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/formandos') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/formandos' style={this.props.path === '/formandos' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/formandos' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fa fa-graduation-cap' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Formandos</span>
              {this.props.contrato.cadastrouFormandos === 1 ? (
                <small style={styles.successBadgeStyle} />
              ) : (
                <small style={styles.dangerBadgeStyle} />
              )}
            </div>
          </Link>
        </li>
        {/* 3) Instagram */}
        <li
          onClick={this.fecharMenu.bind(this)}
          style={this.props.path === '/instagram' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/instagram') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/instagram') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/instagram' style={this.props.path === '/instagram' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/instagram' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fab fa-instagram' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Instagram</span>
              {this.props.arrobas.length > 0 ? (
                <small style={styles.successBadgeStyle} />
              ) : (
                <small style={styles.dangerBadgeStyle} />
              )}
            </div>
          </Link>
        </li>
        {/* 4) Cronograma */}
        <li
          onClick={this.fecharMenu.bind(this)}
          style={this.props.path === '/cronograma' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/cronograma') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/cronograma') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/cronograma' style={this.props.path === '/cronograma' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/cronograma' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fa fa-calendar-check-o' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Cronograma</span>
              <small style={styles.infoBadgeStyle}>
                <i className='fa fa-info-circle' style={styles.badgeIconStyle} />
              </small>
            </div>
          </Link>
        </li>
        {/* 5) Orientações fotográficas */}
        <li
          onClick={this.fecharMenu.bind(this)}
          id='orientacoesFotograficas'
          style={this.props.path === '/orientacoes-fotograficas' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/orientacoes-fotograficas') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/orientacoes-fotograficas') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/orientacoes-fotograficas' style={this.props.path === '/orientacoes-fotograficas' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/orientacoes-fotograficas' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fa fa-camera' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Orientações fotográficas</span>
              <small style={styles.infoBadgeStyle}>
                <i className='fa fa-info-circle' style={styles.badgeIconStyle} />
              </small>
            </div>
          </Link>
        </li>
        {/* 6) Pedidos */}
        {this.props.contrato.sistemaPagto === 1 ? (
          <li
            onClick={this.fecharMenu.bind(this)}
            style={this.props.path === '/meus-pedidos' ? styles.activeMenuItemStyle : styles.menuItemStyle}
            onMouseEnter={(e) => {
              if (this.props.path !== '/meus-pedidos') {
                e.currentTarget.style.background = '#2a2a2a';
              }
            }}
            onMouseLeave={(e) => {
              if (this.props.path !== '/meus-pedidos') {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <Link to='/meus-pedidos' style={this.props.path === '/meus-pedidos' ? styles.activeLinkStyle : styles.linkStyle}>
              <div style={this.props.path === '/meus-pedidos' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
                <i className='fa fa-shopping-cart' style={styles.iconStyle} />
              </div>
              <div style={styles.textContainerStyle}>
                <span style={styles.labelTextStyle}>Pedidos</span>
                <small style={styles.infoBadgeStyle}>
                  <i className='fa fa-info-circle' style={styles.badgeIconStyle} />
                </small>
              </div>
            </Link>
          </li>
        ) : null}
        {/* 7) Pedidos da comissão (condicional: pagamento_comissao) */}
        {this.props.contrato.pagamento_comissao ? (
          <li
            onClick={this.fecharMenu.bind(this)}
            style={this.props.path === '/pedidos-comissao' ? styles.activeMenuItemStyle : styles.menuItemStyle}
            onMouseEnter={(e) => {
              if (this.props.path !== '/pedidos-comissao') {
                e.currentTarget.style.background = '#2a2a2a';
              }
            }}
            onMouseLeave={(e) => {
              if (this.props.path !== '/pedidos-comissao') {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <Link to='/pedidos-comissao' style={this.props.path === '/pedidos-comissao' ? styles.activeLinkStyle : styles.linkStyle}>
              <div style={this.props.path === '/pedidos-comissao' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
                <i className='fas fa-shopping-bag' style={styles.iconStyle} />
              </div>
              <div style={styles.textContainerStyle}>
                <span style={styles.labelTextStyle}>Pedidos da comissão</span>
              </div>
            </Link>
          </li>
        ) : null}
        {/* 8) Aprovação do convite */}
        <li
          onClick={this.fecharMenu.bind(this)}
          id='aprovacaoConvite'
          style={this.props.path === '/aprovacao-convite' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/aprovacao-convite') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/aprovacao-convite') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/aprovacao-convite' style={this.props.path === '/aprovacao-convite' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/aprovacao-convite' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fa fa-envelope' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Aprovação do convite</span>
              {this._verificarConviteAprovado() ? (
                <small style={styles.successBadgeStyle} />
              ) : (
                <small style={styles.dangerBadgeStyle} />
              )}
            </div>
          </Link>
        </li>
        {/* 9) Personalização */}
        <li
          style={styles.menuItemStyle}
          onMouseEnter={(e) => { e.currentTarget.style.background = '#2a2a2a'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
        >
          <a
            href={this._buildPersonalizacaoUrl()}
            target='_blank'
            rel='noopener noreferrer'
            onClick={this._abrirPersonalizacao.bind(this)}
            style={styles.linkStyle}
          >
            <div style={styles.iconContainerStyle}>
              <i className='fa fa-magic' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Personalização</span>
              <small style={styles.successBadgeStyle} />
            </div>
          </a>
        </li>
        {/* 10) Distribuir itens (condicional: pagamento_comissao) */}
        {this.props.contrato.pagamento_comissao ? (
          <li
            onClick={this.fecharMenu.bind(this)}
            style={this.props.path === '/distribuir-itens' ? styles.activeMenuItemStyle : styles.menuItemStyle}
            onMouseEnter={(e) => {
              if (this.props.path !== '/distribuir-itens') {
                e.currentTarget.style.background = '#2a2a2a';
              }
            }}
            onMouseLeave={(e) => {
              if (this.props.path !== '/distribuir-itens') {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <Link to='/distribuir-itens' style={this.props.path === '/distribuir-itens' ? styles.activeLinkStyle : styles.linkStyle}>
              <div style={this.props.path === '/distribuir-itens' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
                <i className='fas fa-tags' style={styles.iconStyle} />
              </div>
              <div style={styles.textContainerStyle}>
                <span style={styles.labelTextStyle}>Distribuir itens</span>
                {this.props.contrato.compras_comissao_distribuidas ? (
                  <small style={styles.successBadgeStyle} />
                ) : (
                  <small style={styles.dangerBadgeStyle} />
                )}
              </div>
            </Link>
          </li>
        ) : null}
        {/* 11) Distribuir brindes (condicional: sistemaPagto===1 e distribuiuBrindes!==null) */}
        {this.props.contrato.sistemaPagto === 1 &&
        this.props.contrato.distribuiuBrindes !== null ? (
          <li
            onClick={this.fecharMenu.bind(this)}
            style={this.props.path === '/distribuir-brindes' ? styles.activeMenuItemStyle : styles.menuItemStyle}
            onMouseEnter={(e) => {
              if (this.props.path !== '/distribuir-brindes') {
                e.currentTarget.style.background = '#2a2a2a';
              }
            }}
            onMouseLeave={(e) => {
              if (this.props.path !== '/distribuir-brindes') {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <Link to='/distribuir-brindes' style={this.props.path === '/distribuir-brindes' ? styles.activeLinkStyle : styles.linkStyle}>
              <div style={this.props.path === '/distribuir-brindes' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
                <i className='fa fa-gifts' style={styles.iconStyle} />
              </div>
              <div style={styles.textContainerStyle}>
                <span style={styles.labelTextStyle}>Distribuir brindes</span>
                {this.props.contrato.distribuiuBrindes === 1 ? (
                  <small style={styles.successBadgeStyle} />
                ) : (
                  <small style={styles.dangerBadgeStyle} />
                )}
              </div>
            </Link>
          </li>
        ) : null}
        {/* 12) Faturamento/entrega (condicional: sistemaPagto===1) */}
        {this.props.contrato.sistemaPagto === 1 ? (
          <li
            onClick={this.fecharMenu.bind(this)}
            style={this.props.path === '/entrega' ? styles.activeMenuItemStyle : styles.menuItemStyle}
            onMouseEnter={(e) => {
              if (this.props.path !== '/entrega') {
                e.currentTarget.style.background = '#2a2a2a';
              }
            }}
            onMouseLeave={(e) => {
              if (this.props.path !== '/entrega') {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <Link to='/entrega' style={this.props.path === '/entrega' ? styles.activeLinkStyle : styles.linkStyle}>
              <div style={this.props.path === '/entrega' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
                <i className='fa fa-truck' style={styles.iconStyle} />
              </div>
              <div style={styles.textContainerStyle}>
                <span style={styles.labelTextStyle}>Faturamento/entrega</span>
                {this.props.contrato.enderecoPreenchido ? (
                  <small style={styles.successBadgeStyle} />
                ) : (
                  <small style={styles.dangerBadgeStyle} />
                )}
              </div>
            </Link>
          </li>
        ) : null}
        {/* 13) Convite online */}
        <li
          style={styles.menuItemStyle}
          onMouseEnter={(e) => { e.currentTarget.style.background = '#2a2a2a'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
        >
          <a
            href='https://online.alphaconvites.com.br/login'
            target='_blank'
            rel='noopener noreferrer'
            onClick={this.fecharMenu.bind(this)}
            style={styles.linkStyle}
          >
            <div style={styles.iconContainerStyle}>
              <i className='fa fa-ticket-alt' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Convite online</span>
              <small style={styles.successBadgeStyle} />
            </div>
          </a>
        </li>
        {/* 14) Acessar Loja (condicional: weblojaLiberada) */}
        {this.props.contrato.weblojaLiberada ? (
          <li
            style={styles.menuItemStyle}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#2a2a2a'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
          >
            <a
              href='#'
              onClick={(e) => { e.preventDefault(); this.fecharMenu(); this._abrirWebloja(); }}
              style={styles.linkStyle}
            >
              <div style={styles.iconContainerStyle}>
                <i className='fa fa-shopping-cart' style={styles.iconStyle} />
              </div>
              <div style={styles.textContainerStyle}>
                <span style={styles.labelTextStyle}>Acessar Loja</span>
                <small style={styles.successBadgeStyle} />
              </div>
            </a>
          </li>
        ) : null}
      </ul>
    );
  }

  _abrirConvite() {
    const formando = this._encontrarFormandoDoUsuario();
    if (formando && formando.documento) {
      const cpf = formando.documento.replace(/\D/g, '');
      window.open(
        `https://online.alphaconvites.com.br?cpf=${cpf}`,
        '_blank'
      );
    }
  }

  _buildPersonalizacaoUrl() {
    // Encaminha o formando direto pra tela de personalização no Diagramador.
    // Backend resolve contract+aluno → 302 pro workspace tokenizado.
    const params = new URLSearchParams();
    // Como o Diagramador casa o contrato (sync agency-pull-sync.service.js):
    //   coluna agency_contract_id  ← c.id     (ex: 2136)
    //   coluna contract_number     ← c.numero (ex: 31724)
    // O endpoint busca por agency_contract_id OU por contract_number. Enviamos
    // os dois a partir do objeto do contrato no front (que tem id e numero),
    // sem depender de props.numeroContrato (que pode chegar 0 do login).
    const contrato = this.props.contrato || {};
    if (contrato.id) params.set('agency_contract_id', String(contrato.id));
    if (contrato.numero) params.set('contract_number', String(contrato.numero));

    const formando = this._encontrarFormandoDoUsuario && this._encontrarFormandoDoUsuario();
    // agency_student_id (= formando.id na agencia) da match exato no Diagramador.
    // student_name e fallback e usa LIKE, podendo falhar/ambiguar com nomes parciais.
    if (formando && formando.id) params.set('agency_student_id', String(formando.id));
    const nome = (formando && (formando.nome || formando.name))
      || (this.props.usuario && this.props.usuario.nome)
      || '';
    if (nome) params.set('student_name', nome);

    // Sinaliza ao backend para responder com HTTP 302 (redirect) em vez de JSON.
    // Sem este flag, o endpoint retorna JSON e o navegador exibe texto cru.
    params.set('redirect', 'true');

    return `${URL_DIAGRAMADOR_PERSONALIZACAO}?${params.toString()}`;
  }

  _abrirPersonalizacao(e) {
    // Navegação direta para o endpoint da API. O backend resolve contract+aluno
    // e retorna 302 para o workspace tokenizado do formando.
    // Não usamos fetch porque o backend bloqueia CORS para o localhost/origens
    // do front; a navegação normal do navegador não é afetada por CORS.
    this.fecharMenu();
    // Não chamamos preventDefault — deixamos o <a target="_blank"> abrir normalmente.
  }

  _abrirWebloja() {
    const formando = this._encontrarFormandoDoUsuario();
    const numeroContrato =
      (this.props.contrato && this.props.contrato.numero) ||
      this.props.numeroContrato ||
      '';
    if (formando && formando.documento && numeroContrato) {
      const cpf = formando.documento.replace(/\D/g, '');
      window.open(
        `https://alphapress.com.br/login.html?cpf=${encodeURIComponent(cpf)}&contrato=${encodeURIComponent(numeroContrato)}`,
        '_blank',
        'noopener,noreferrer'
      );
    } else {
      window.open('https://alphapress.com.br/login.html', '_blank', 'noopener,noreferrer');
    }
  }

  _encontrarFormandoDoUsuario() {
    const emailUsuario = this.props.usuario && this.props.usuario.email;
    if (!emailUsuario || !this.props.formandos) return null;

    // Busca por vínculo direto (formando) ou por email igual (comissão que também é formando)
    return this.props.formandos.find((f) => {
      const emailFormando = f.email || (f.usuario && f.usuario.email);
      return (
        f.usuario === this.props.usuario.id ||
        (f.usuario && f.usuario.id === this.props.usuario.id) ||
        (emailFormando && emailFormando.toLowerCase() === emailUsuario.toLowerCase())
      );
    });
  }

  _renderMenuFormando() {
    const styles = this._getCommonStyles();

    return (
      <ul className='sidebar-menu' style={{ padding: '10px 0', listStyle: 'none', margin: 0 }}>
        <li
          style={styles.menuItemStyle}
          onMouseEnter={(e) => { e.currentTarget.style.background = '#2a2a2a'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
        >
          <a
            href='#'
            onClick={(e) => { e.preventDefault(); this.fecharMenu(); this._abrirConvite(); }}
            style={styles.linkStyle}
          >
            <div style={styles.iconContainerStyle}>
              <i className='fa fa-eye' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Convite online</span>
              <small style={styles.successBadgeStyle} />
            </div>
          </a>
        </li>
        {this.props.contrato.weblojaLiberada ? (
          <li
            style={styles.menuItemStyle}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#2a2a2a'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
          >
            <a
              href='#'
              onClick={(e) => { e.preventDefault(); this.fecharMenu(); this._abrirWebloja(); }}
              style={styles.linkStyle}
            >
              <div style={styles.iconContainerStyle}>
                <i className='fa fa-shopping-cart' style={styles.iconStyle} />
              </div>
              <div style={styles.textContainerStyle}>
                <span style={styles.labelTextStyle}>Acessar Loja</span>
                <small style={styles.successBadgeStyle} />
              </div>
            </a>
          </li>
        ) : null}
        {this.props.contrato.sistemaPagto === 1 ? (
          <li
            onClick={this.fecharMenu.bind(this)}
            style={this.props.path === '/comprar' ? styles.activeMenuItemStyle : styles.menuItemStyle}
            onMouseEnter={(e) => {
              if (this.props.path !== '/comprar') {
                e.currentTarget.style.background = '#2a2a2a';
              }
            }}
            onMouseLeave={(e) => {
              if (this.props.path !== '/comprar') {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <Link to='/comprar' style={this.props.path === '/comprar' ? styles.activeLinkStyle : styles.linkStyle}>
              <div style={this.props.path === '/comprar' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
                <i className='fa fa-shopping-cart' style={styles.iconStyle} />
              </div>
              <div style={styles.textContainerStyle}>
                <span style={styles.labelTextStyle}>Comprar itens</span>
                {this.props.contrato.distribuiuItens === 1 ? (
                  <small style={styles.successBadgeStyle} />
                ) : (
                  <small style={styles.dangerBadgeStyle} />
                )}
              </div>
            </Link>
          </li>
        ) : null}
        {this.props.contrato.personalizacaoLiberada ? (
          <li
            style={styles.menuItemStyle}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#2a2a2a'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
          >
            <a
              href={this._buildPersonalizacaoUrl()}
              target='_blank'
              rel='noopener noreferrer'
              onClick={this.fecharMenu.bind(this)}
              style={styles.linkStyle}
            >
              <div style={styles.iconContainerStyle}>
                <i className='fa fa-magic' style={styles.iconStyle} />
              </div>
              <div style={styles.textContainerStyle}>
                <span style={styles.labelTextStyle}>Personalização</span>
                <small style={styles.successBadgeStyle} />
              </div>
            </a>
          </li>
        ) : null}
        <li
          onClick={this.fecharMenu.bind(this)}
          style={this.props.path === '/' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/' style={this.props.path === '/' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fas fa-file-alt' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Contrato</span>
              <small style={styles.infoBadgeStyle}>
                <i className='fa fa-info-circle' style={styles.badgeIconStyle} />
              </small>
            </div>
          </Link>
        </li>
        {this.props.contrato.sistemaPagto === 1 ? (
          <li
            onClick={this.fecharMenu.bind(this)}
            style={this.props.path === '/meus-pedidos' ? styles.activeMenuItemStyle : styles.menuItemStyle}
            onMouseEnter={(e) => {
              if (this.props.path !== '/meus-pedidos') {
                e.currentTarget.style.background = '#2a2a2a';
              }
            }}
            onMouseLeave={(e) => {
              if (this.props.path !== '/meus-pedidos') {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <Link to='/meus-pedidos' style={this.props.path === '/meus-pedidos' ? styles.activeLinkStyle : styles.linkStyle}>
              <div style={this.props.path === '/meus-pedidos' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
                <i className='fas fa-receipt' style={styles.iconStyle}></i>
              </div>
              <div style={styles.textContainerStyle}>
                <span style={styles.labelTextStyle}>Meus pedidos</span>
                <small style={styles.infoBadgeStyle}>
                  <i className='fa fa-info-circle' style={styles.badgeIconStyle} />
                </small>
              </div>
            </Link>
          </li>
        ) : null}
      </ul>
    );
  }

  _renderMenuAlphaE() {
    const styles = this._getCommonStyles();

    return (
      <ul className='sidebar-menu' style={{ padding: '10px 0', listStyle: 'none', margin: 0 }}>
        <li
          onClick={this.fecharMenu.bind(this)}
          style={this.props.path === '/formandos' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/formandos') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/formandos') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/formandos' style={this.props.path === '/formandos' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/formandos' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fa fa-graduation-cap' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Formandos</span>
              {this.props.contrato.cadastrouFormandos === 1 ? (
                <small style={styles.successBadgeStyle} />
              ) : (
                <small style={styles.dangerBadgeStyle} />
              )}
            </div>
          </Link>
        </li>
        <li
          onClick={this.fecharMenu.bind(this)}
          style={this.props.path === '/itens' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/itens') {
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.22)';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/itens') {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.12)';
            }
          }}
        >
          <Link to='/distribuir-itens' style={this.props.path === '/itens' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/itens' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fa fa-shopping-cart' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Distribuir itens</span>
              {this.props.contrato.distribuiuItens === 1 ? (
                <small style={styles.successBadgeStyle} />
              ) : (
                <small style={styles.dangerBadgeStyle} />
              )}
            </div>
          </Link>
        </li>
        <li
          onClick={this.fecharMenu.bind(this)}
          style={this.props.path === '/instagram' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/instagram') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/instagram') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/instagram' style={this.props.path === '/instagram' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/instagram' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fab fa-instagram' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Instagram</span>
              {this.props.arrobas.length > 0 ? (
                <small style={styles.successBadgeStyle} />
              ) : (
                <small style={styles.dangerBadgeStyle} />
              )}
            </div>
          </Link>
        </li>
        <li
          onClick={this.fecharMenu.bind(this)}
          id='aprovacaoConvite'
          style={this.props.path === '/aprovacao-convite' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/aprovacao-convite') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/aprovacao-convite') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/aprovacao-convite' style={this.props.path === '/aprovacao-convite' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/aprovacao-convite' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fa fa-envelope' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Aprovação do convite</span>
              {this._verificarConviteAprovado() ? (
                <small style={styles.successBadgeStyle} />
              ) : (
                <small style={styles.dangerBadgeStyle} />
              )}
            </div>
          </Link>
        </li>
        <li
          onClick={this.fecharMenu.bind(this)}
          style={this.props.path === '/' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/' style={this.props.path === '/' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fas fa-file-alt' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Contrato</span>
              <small style={styles.infoBadgeStyle}>
                <i className='fa fa-info-circle' style={styles.badgeIconStyle} />
              </small>
            </div>
          </Link>
        </li>
        <li
          onClick={this.fecharMenu.bind(this)}
          id='orientacoesFotograficas'
          style={this.props.path === '/orientacoes-fotograficas' ? styles.activeMenuItemStyle : styles.menuItemStyle}
          onMouseEnter={(e) => {
            if (this.props.path !== '/orientacoes-fotograficas') {
              e.currentTarget.style.background = '#2a2a2a';
            }
          }}
          onMouseLeave={(e) => {
            if (this.props.path !== '/orientacoes-fotograficas') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <Link to='/orientacoes-fotograficas' style={this.props.path === '/orientacoes-fotograficas' ? styles.activeLinkStyle : styles.linkStyle}>
            <div style={this.props.path === '/orientacoes-fotograficas' ? styles.activeIconContainerStyle : styles.iconContainerStyle}>
              <i className='fa fa-camera' style={styles.iconStyle} />
            </div>
            <div style={styles.textContainerStyle}>
              <span style={styles.labelTextStyle}>Orientações fotográficas</span>
              <small style={styles.infoBadgeStyle}>
                <i className='fa fa-info-circle' style={styles.badgeIconStyle} />
              </small>
            </div>
          </Link>
        </li>
      </ul>
    );
  }

  render() {
    return (
      <aside className='main-sidebar'>
        <section className='sidebar'>
          <style>
            {`
              /* Quando o sidebar está minimizado */
              .sidebar-collapse .sidebar-menu > li > a {
                justify-content: center !important;
                padding: 8px 0 !important;
              }

              /* Esconde completamente texto e badges quando minimizado */
              .sidebar-collapse .sidebar-menu > li > a > div:last-child,
              .sidebar-collapse .sidebar-menu > li > a span,
              .sidebar-collapse .sidebar-menu > li > a small {
                display: none !important;
              }

              /* Mantém apenas o container do ícone visível quando minimizado */
              .sidebar-collapse .sidebar-menu > li > a > div:first-child {
                margin: 0 !important;
              }

              /* Ajusta os itens do menu quando minimizado */
              .sidebar-collapse .sidebar-menu > li {
                margin: 3px 0 !important;
              }
            `}
          </style>
          {!this.props.contrato.contratante ||
          this.props.contrato.contratante === null ||
          !this.props.contrato.contratante.includes('Alpha-e')
            ? this.props.usuario.tipo === 'comissao'
              ? this._renderMenuComissao()
              : this.props.usuario.tipo === 'formando'
              ? this._renderMenuFormando()
              : null
            : this._renderMenuAlphaE()}
          <div style={{
            borderTop: '1px solid #2a2a2a',
            margin: '8px',
            paddingTop: '8px'
          }}>
            <a
              href='https://www.instagram.com/alphaconvites/'
              target='_blank'
              rel='noopener noreferrer'
              onClick={this.fecharMenu.bind(this)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '8px 10px',
                color: '#e5e5e5',
                textDecoration: 'none',
                borderRadius: '6px',
                transition: 'background 0.2s ease'
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#2a2a2a'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
              <div style={{ width: '25px', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className='fab fa-instagram' style={{ fontSize: '18px', color: '#e1306c' }} />
              </div>
              <span style={{ fontSize: '14px', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                Nosso Instagram
              </span>
            </a>
          </div>
        </section>
      </aside>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    numeroContrato: state.usuario.numeroContrato,
    contrato: state.contrato.especifico,
    caminho: state.caminho.atual,
    formandos: state.formando.todos,
    arrobas: state.instagram.todos,
  };
};

export default connect(mapStateToProps, {
  obterArrobasPeloContrato,
  descobrirContrato,
  obterFormandosPeloContrato,
})(Menu);
